module.exports = __webpack_public_path__ + "static/img/aa-9.0262f0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aa-9.png
// module id = tXHs
// module chunks = 1